<template>
  <div>
    <!--     <b-carousel id="carousel1" style="text-shadow: 1px 1px 2px #333;" indicators background="#ababab" :interval="interval" :img-width="width" :img-height="height" v-model="slide" @sliding-start="onSlideStart" @sliding-end="onSlideEnd">
      <b-carousel-slide v-for="img in images">
        <img  slot="img" class="d-block  bannerImg" :style="{height: imageHeight+'px !important'}" :src="img" alt="image slot">
      </b-carousel-slide>
    </b-carousel> -->
    <Swiper :list="value" :aspect-ratio="aspectRatio" :interval="interval" auto ></Swiper>
  </div>
</template>
<script>
import { Swiper } from 'vux'
export default {
  name: 'ImageSlider',
  components: {
    Swiper
  },
  props: {
    interval: {
      type: Number,
      default: 3000
    },

    aspectRatio: {
      type: [Number, String], // high/width 
      default: 0.68
    },
    value: {
      type: Array,
      default: () => {
        let images = [

          {
            url: 'javascript:',
            img: 'https://www.kolpartner.cn/kol-rest/uploadfile/2018/1016/aac6e01c3b8e06203b31f3abaf2206d3.jpg',
            title: ''

          },
          // {
          //   url: 'javascript:',
          //   img: 'https://www.kolpartner.cn/kol-rest/uploadfile/2018/1112/c89a7cf092974b0e0034b246826f9c9e.jpg',
          //   title: ''

          // },
          {
            url: 'javascript:',
            img: 'https://www.kolpartner.cn/kol-rest/uploadfile/2018/0918/5b78c8a0a0634d6179e739b841bafa35.png',
            title: ''

          },
          {
            url: 'javascript:',
            img: 'https://www.kolpartner.cn/kol-rest/uploadfile/2018/1010/3710136a81d34cd80a2ea44ecf4e9a0f.png',
            title: ''

          },





        ]
        return images;

      }
    }
  },
  data() {
    return {
      slide: 0,
      sliding: null,
      images: this.value,
      imageHeight: 300,
    }
  },
  computed: {
    // getImageHeight(){
    //   let width  = window.innerWidth;
    //   height = Math.ceil(this.aspectRatio * parseInt(width));
    //   return height;
    // }
  },
  mounted() {
    let width = window.innerWidth;
    let height = Math.ceil(parseFloat(this.aspectRatio) * parseInt(width));
    this.imageHeight = height;
  },
  methods: {
    onSlideStart(slide) {
      this.sliding = true
    },
    onSlideEnd(slide) {
      this.sliding = false
    }
  }
}

</script>
<style>
.bannerImg {
  width: 100% !important;
  height: auto;
  object-fit: cover;
}

/*  .carouselSlide{
    background-position: 50% 50%;
    background-size: cover;
    padding-top: 56.25%;
    width:1024px;
    background-repeat: no-repeat;
    background: url('https://media.allure.com/photos/5a9ef8b4dc4fe0148f450231/16:9/w_1600,c_limit/best-japanese-beauty-products.jpg');
  }*/

</style>



// WEBPACK FOOTER //
// src/components/Header/ImageSlider.vue